import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const ClientLogoWall = () => {
  const [logos, setLogos] = useState([]);
  useEffect(() => {
    axios.get(`${API}/api/public/customer-logos`).then((r) => setLogos(r.data)).catch(() => {});
  }, []);

  if (logos.length === 0) return null;

  return (
    <section className="py-14 md:py-20 px-4 bg-white" data-testid="client-logo-wall">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs font-black uppercase tracking-[0.2em] mb-3">Trusted By {logos.length}+ Brands</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900">
            Brands That <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">Grow With Us</span>
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-10 items-center">
          {logos.map((l) => {
            const img = (
              <img
                src={`${API}/api/public/customer-logos/${l.id}/image`}
                alt={l.brand_name ? `${l.brand_name} — launched by BrandBorn` : l.name.replace(/\.[^.]+$/, "")}
                loading="lazy"
                className="max-h-20 max-w-full object-contain grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 ease-out"
              />
            );
            return l.has_case_study && l.slug ? (
              <Link key={l.id} to={`/case-study/${l.slug}`} data-testid={`client-logo-${l.id}`} title={`${l.brand_name} case study — launched by BrandBorn`} className="flex items-center justify-center h-24 px-4 group cursor-pointer">
                {img}
              </Link>
            ) : (
              <div key={l.id} data-testid={`client-logo-${l.id}`} className="flex items-center justify-center h-24 px-4 group">
                {img}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClientLogoWall;
